import { connect } from "react-redux";

import AddOptionOrSelectFromRadio from "../../shared_components/add_option_or_select_from_radio";
import {
  cancelSlideDeckButtonClicked, submitSlideDeckButtonClicked,
  slideDeckRadioButtonClicked, slideDeckTextChange, NEW_VALUE
} from "../actions/slide_decks";

const mapStateToProps = (state) => {
  const s = state.main.slideDecks;

  const hidden = !s.slideDeckBeingSaved;
  const selectedOptionValue = s.selectedOptionValue;
  const options = s.options;
  const newOption = s.newOption;
  const textValue = s.textValue;

  const loadingOptions = s.loadingOptions;
  const showSpinner = s.submittingSlide;

  const newOptionNeedsName = selectedOptionValue === NEW_VALUE && !textValue;

  const newValue = NEW_VALUE;
  const placeholder = "New slide deck name";
  const title = "Add this chart to a Slide Deck";

  return {
    hidden, selectedOptionValue, options,
    textValue, newOption, loadingOptions, showSpinner, newOptionNeedsName,
    newValue, placeholder, title
  };
};

const mapDispatchToProps = dispatch => ({
  onAdd: () => { dispatch(submitSlideDeckButtonClicked()); },
  onCancel: () => { dispatch(cancelSlideDeckButtonClicked()); },
  radioSelect: (e) => {
    dispatch(slideDeckRadioButtonClicked(e.target.value));
  },
  textChange: (e) => {
    dispatch(slideDeckTextChange(e.target.value));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AddOptionOrSelectFromRadio);
